import { render, staticRenderFns } from "./IngPrint.vue?vue&type=template&id=0fb1da40&scoped=true"
import script from "./IngPrint.vue?vue&type=script&lang=js"
export * from "./IngPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb1da40",
  null
  
)

export default component.exports